import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv1310GetResultModel, Inv1310GetResultSchema } from './get.schema'

export async function fetchInv1310(id: number): Promise<Inv1310GetResultModel> {
  const response = await axios.get<Inv1310GetResultModel>(
    `/api/warehouse/inv1310/${id}`
  )
  console.log('fetchInv1310', response.data)
  return Inv1310GetResultSchema.parse(response.data)
}

export const getInv1310ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv1310', id],
    queryFn: () => fetchInv1310(id),
  })

export async function printInv1310(id: number): Promise<void> {
  const response = await axios.get(`/api/warehouse/inv1310/${id}/print`, {
    responseType: 'blob',
  })
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `ใบเบิกคืนสินค้า_inv1310_${id}_.docx`)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
